// extracted by mini-css-extract-plugin
export default {"content":"ContactItem_content__ewN9U","icon":"ContactItem_icon__qzINN","title":"ContactItem_title__3vgWI","link":"ContactItem_link__P+TvW"};